import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-x1" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-8" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center px-x1 py-2 o-text-caption bg-brandy"
}
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col mt-3"
}
const _hoisted_6 = { class: "flex flex-wrap gap-x1" }
const _hoisted_7 = { class: "o-text-caption" }
const _hoisted_8 = { class: "o-text-caption" }

import { ProductDiscountType, ProductPriceModel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import { computed } from 'vue';
import dictionaryService from '@/core/dictionary/dictionary.service';
import ProductNetPrice from '@/b2b/product/ui/ProductNetPrice.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverlaySpotPrice',
  props: {
    price: null,
    large: { type: Boolean },
    variantId: null
  },
  setup(__props: any) {

const props = __props as {
    price: ProductPriceModel;
    large?: boolean;
    variantId?: string;
}



const globalLabels = useGlobalLabels(GlobalLabels.product);

const isMyBoliaBoost = computed(() => props.price.discount?.type === ProductDiscountType.MyBoliaBoost);

const formattedDiscountLabel = computed(() => {
    if (!props.price.discount) {
        return '';
    }
    const label = isMyBoliaBoost.value
        ? globalLabels.myBoliaDiscount
        : globalLabels.discount;
    return dictionaryService.formatNamed(label, { discount: props.price.discount?.percentage });
});

const discountTextStyling = computed(() => {
    if (isMyBoliaBoost.value) {
        return 'flex items-center px-x2 py-2 o-text-caption bg-brandy';
    } else if (props.large) {
        return 'text-16 sm:text-20';
    }
    return '';
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", {
          class: _normalizeClass(["o-text-caption", { 'text-16 sm:text-20': __props.large, 'font-bold': __props.price.discount?.discount }])
        }, _toDisplayString(__props.price.salesPrice.amount), 3),
        (_unref(isMyBoliaBoost))
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).myBoliaDiscount, {discount: __props.price.discount?.percentage})), 1))
          : _createCommentVNode("", true),
        (!_unref(isMyBoliaBoost) && __props.price.discount?.discount)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("p", {
                class: _normalizeClass(["o-text-caption line-through", { 'text-16 sm:text-20': __props.large }])
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(`${_unref(globalLabels).previousListPrice}:`), 1),
                _createTextVNode(" " + _toDisplayString(__props.price.listPrice.amount), 1)
              ], 2),
              _createElementVNode("p", {
                class: _normalizeClass(["o-text-caption", _unref(discountTextStyling)])
              }, _toDisplayString(_unref(formattedDiscountLabel)), 3)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      (__props.variantId)
        ? (_openBlock(), _createBlock(ProductNetPrice, {
            key: 0,
            "variant-id": __props.variantId
          }, null, 8, ["variant-id"]))
        : _createCommentVNode("", true)
    ]),
    (_unref(isMyBoliaBoost))
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.price.listPrice.amount), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(globalLabels).nonMemberDiscountText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})